export const vacancyTemplateDataHelper = (data, count, rest) => {
    return {
        ...rest,
        count,

        list: data.map(
            (template) => {
                return template
            }
        ),
    }
}

export const vacancyTemplateDataHelperUpdate = (templates) => {
    return templates
}

export const vacancyTemplateSubmitHelper = (tempate) => {
    return tempate
}

export const removeUnderscoreAndCapitalize = (text) => {
    return text.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
}